<template>
  <div class="capture-area-generate-qr" ref="captureDivGenerateQR">
    <div style="text-align:right;">
      <div
        class="btn btn-sm btn-icon btn-active-color-primary" v-on:click="goToDMPayPage();"
      >
        <span class="svg-icon svg-icon-1">
          <inline-svg src="media/icons/duotone/Navigation/Close.svg" />
        </span>
      </div>
    </div>
<p style="display:none;">{{qrCode}}</p>
<div class="col-xxl-12 mb-5 text-center">
      <img :src="matchinpayLogo" :style="logoStyle" />
    </div>
    <div style="position: relative; display: inline-block;">
      
      <qrcode-vue :value="qrCode" :size="200" level="H" />
      <img src="media/logos/qrph_logo.png" id="logo" style="
        position: absolute; 
        top: 50%; 
        left: 50%; 
        width: 40px; 
        height: 40px; 
        transform: translate(-50%, -50%);
    " />
    </div>
    <p style="color: red; font-weight: bold;">⚠ DO NOT REUSE ⚠</p>
    <p class="text-center fw-bolder">{{ now }}</p>
    <div class="row mb-10 fw-bolder">
        <button type="button" class="btn btn-primary"  v-on:click="downloadAsImage()" >
          <span class="indicator-label"> Download Image </span>
        </button>
    </div>
    <!-- Hidden Canvas -->
    <canvas ref="canvas" style="display: none;"></canvas>
  </div>
</template>


<style >
.capture-area-generate-qr {
  font-family: "Poppins", sans-serif;
  width: 100%;
  padding: 20px;
  background-color: rgb(255, 255, 255);
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 10px;
}
</style>


<script setup>
import { ref, onMounted, onUnmounted, defineProps, nextTick  } from "vue";
import { ecShopAdvisoryVisibility } from "@/api/common";
import { useRouter } from "vue-router"; 
import domtoimage from "dom-to-image";

const router = useRouter();
const captureDivGenerateQR = ref(null);
const canvas = ref(null);
const props = defineProps(["qrCode"]);




onMounted(() => {

  if(props.qrCode === undefined){
    router.push({ name: "mgpay"});
  } else {
    hideECShopAdvisory();
    onResize();
  }
  
});



const hideECShopAdvisory = () => {
  ecShopAdvisoryVisibility.hide();
};

const showECShopAdvisory = () => {
  ecShopAdvisoryVisibility.show();
};

const goToDMPayPage = () => {
  router.push({ name: "mgpay"});
}

const downloadAsImage = async () => {
  console.log("downloadAsImage");

  await nextTick(); // Ensures Vue has finished rendering
  if (!captureDivGenerateQR.value) {
    console.error("Error: captureDivGenerateQR is null!");
    return;
  }


   domtoimage.toPng(captureDivGenerateQR.value, {
      filter: (node) => node.tagName !== "LINK", // Ignores external stylesheets
      useCORS: true,
    })
    .then((dataUrl) => {
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = "screenshot.png";
      link.click();
    })
    .catch((error) => alert("Error capturing image: " + error));

};



const windowWidth = ref(window.innerWidth);
const matchinpayLogo = ref("");
const logoStyle = ref({});

const onResize = async  () =>  {
  //this.windowHeight = window.innerHeight;
  windowWidth.value = window.innerWidth;
  if(windowWidth.value <= 450){
    matchinpayLogo.value = await convertImageToBase64("https://images.empoweredconsumerism-static-files.com/ecp/MG_PAY_MOBILE.png");
    logoStyle.value = {width:"100px", height: "auto"}
  } else {
    matchinpayLogo.value = await convertImageToBase64("https://images.empoweredconsumerism-static-files.com/ecp/MG_PAY_PC.png");
      logoStyle.value = {width:"300px", height: "auto"}
  }
}


const convertImageToBase64 = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous'; // Important for remote images
    img.onload = () => {
      const canvas = document.createElement('canvas'); // ← Safe, temp canvas
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = reject;
    img.src = url;
  });
};


const now = ref(new Date().toLocaleString()); // Default locale format

</script>





<script>
import QrcodeVue from 'qrcode.vue';

export default {
  components: { QrcodeVue },
  data() {
    return {
      text: "https://www.google.com/", // Default QR code text
    };
  },
  // props : {
  //   qrCode : String
  // },
  // setup(props) {
  //   console.log("Received prop:", props.qrCode); // Directly access props
  //   return { qrCode: props.qrCode };
  // }
};
</script>